import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import indexBannerImg from '../../assets/images/index_ad.jpg';
//import indexBannerImg from '../../assets/images/index_newAd.jpg';
export default class Index extends Component{
    constructor(props) {
        super(props);
        this.state = {}
    }
    render() {
        return (
            <div className="content index">
                <Link to="/introduce" key="introduce">
                    <img src={indexBannerImg} alt="" />
                </Link>
            </div>
        )
    }
}